<template>
  <v-container fluid class="monitorSite px-4">
    <br />
    <h1>{{ this.reportTitle }}</h1>

    <!-- <div flex-nowrap class="buttons-left">
        <v-btn class="button" color="primary" v-on:click="sizeColumnsToFit()">Fit to Page</v-btn>
        <v-btn class="button" color="primary" v-on:click="autoSizeColumns(true)">Auto-size (Data Only)</v-btn>
        <v-btn class="button" color="primary" v-on:click="autoSizeColumns(false)">Auto-size (All)</v-btn>
    </div> -->

    <!-- <div style="width: 100%; height: 70vh; border: 1px solid">
      <ag-grid-vue
        id="myGrid"
        style="width: 100%; height: 100%;"
        class="ag-theme-balham center-box elevation-2"
        :columnDefs="columnDefs"
        :rowData="rowData"
        @rowDoubleClicked="onRowDoubleClicked"
        :gridOptions="gridOptions"
      ></ag-grid-vue>
    </div> -->

  </v-container>
</template>

<script>
// @ is an alias to /src
import { adminService } from "@/services/adminService.js";
import router from "@/router";
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "ReportNatPat",
  data: () => ({
    gridOptions: null,
    gridApi: null,
    columnApi: null,
    reportId: null,
    reportTitle: "Summary Compilation Report for National Patterns of R&D Resources",
    columnDefs: [],
    rowData: [],
    chartData: [],
    columnFieldNames: []
  }),
  components: {
    AgGridVue
  },
  created () {
    this.reportId = this.$route.params.reportId;
  },
  beforeRouteUpdate (to, from, next) {
    // const path = `/reports/${id}`
    // if (this.$route.path !== path) {
    //   console.log('before', this.$route.path);
    //   console.log('before', this.$route.path);
    //   //this.$router.push(path);
    // }
    console.log('before', this.$route.path);
    next();
  },
  beforeMount () {
    this.gridOptions = {};
  },
  mounted () {
    let me = this;

    me.gridApi = me.gridOptions.api;
    me.gridColumnApi = me.gridOptions.columnApi;

    adminService
    .getReportRecords(me.reportId)
    .then(function (resp) {
      // console.log('res.data = ' + JSON.stringify(resp.data));
      me.reportTitle = resp.data.reportName;

      for (var i = 0; i < resp.data.columnNames.length; i++) {
        var tmpColumnDef = {};
        // console.log('resp.data.fields[' + i + '] = ' + resp.data.columnNames[i]);
        tmpColumnDef.field = resp.data.columnNames[i];
        me.columnFieldNames.push(resp.data.columnNames[i]);
        // console.log('resp.data.columns[' + i + '] = ' + resp.data.columnLabels[i]);
        tmpColumnDef.headerName = resp.data.columnLabels[i];
        tmpColumnDef.sortable = true;
        tmpColumnDef.filter = true;
        tmpColumnDef.resizable = true;
        tmpColumnDef.cellClass = "text-left";
        me.columnDefs.push(tmpColumnDef);
      }

      me.rowData = resp.data.recordData;
      // console.log('me.rowData = ' + JSON.stringify(me.rowData));
    })
    .catch(function (err) {
      console.error(err);
    });
  },
  methods: {
    onRowDoubleClicked (evt) {
      const selectedRowData = evt.data;
      // console.log('selectedRowData = ' + JSON.stringify(selectedRowData));
      if (selectedRowData) {
        router.push({
          name: "admin.reportdetail",
          params: { reportId: this.reportId, recordDataId: selectedRowData.recordDataId }
        });
      }
    },
    // reports () {
    //   router.push({ name: 'reports' });
    // },
    sizeColumnsToFit () {
      this.gridApi.sizeColumnsToFit();
    },
    autoSizeColumns (header) {
       this.gridColumnApi.autoSizeColumns(this.columnFieldNames, header);
    }

  }
}

</script>

<style scoped>
.buttons-left {
  text-align: left;
}
.button {
  max-height:25px;
  margin: 10px 10px 10px 0px;
}
h1 {
  margin: 0px 0 20px 0;
}
</style>
